// The UI language follows the signed-in user's saved language (X11-411a). The paraglide runtime holds the message strings,
// so switching it changes every `m.*` string from the next render, and the document's lang and dir follow the same language.
import { isLocale, setLocale } from "@/paraglide/runtime.js";
import { applyDirection } from "./direction";

type UiLocale = Parameters<typeof setLocale>[0];

/** The base language of a tag: "ar" for "ar-SA", "en" for "en_AU". */
const baseLanguage = (tag: string): string => (tag.trim().toLowerCase().split(/[-_]/)[0] ?? "").trim();

/**
 * Switches the UI to a saved language. A regional tag switches to its base language ("ar-SA" is Arabic), and a language the
 * app has no messages for leaves the current language as it is. The page is not reloaded: the open screen re-renders when
 * the caller invalidates it. Returns true when the UI now shows the language.
 */
export function applyUserLocale(lang: string | undefined): boolean {
  const base = baseLanguage(lang ?? "");
  if (!base || !isLocale(base)) return false;
  setLocale(base as UiLocale, { reload: false });
  if (typeof document !== "undefined") applyDirection(base);
  return true;
}
